<template>
	<div class="col-md-12">
		<div class="card card-container">
			<h3 class="text-center">Вход в профиль</h3>
			<img id="profile-img" src="@/assets/img/profile/no_gender.png" class="profile-img-card" />
			<ValidationObserver v-slot="{ handleSubmit }">
				<form name="form" class="needs-validation" novalidate @submit.prevent="handleSubmit(submit)">
					<div class="mb-3">
						<label for="email">Email</label>
						<ValidationProvider name="email" rules="required" v-slot="{ errors }">
							<input type="email" class="form-control" v-model="user.email" />
							<span class="text-danger">{{ errors[0] }}</span>
						</ValidationProvider>
					</div>
					<div class="mb-3">
						<label for="password">Пароль</label>
						<ValidationProvider name="password" rules="required|min:6" v-slot="{ errors }">
							<input type="password" class="form-control" v-model="user.password" />
							<span class="text-danger">{{ errors[0] }}</span>
						</ValidationProvider>
					</div>
					<div class="mb-3 d-flex justify-content-between align-items-center">
						<button class="btn btn-primary btn-block" :disabled="loading">
							<span v-show="loading" class="spinner-border spinner-border-sm"></span>
							<span>Войти</span>
						</button>
						<router-link to="/password-request-reset" tag="button" class="btn btn-sm btn-light btn-block"
							>Забыли пароль?</router-link
						>
						<router-link to="/register" tag="button" class="btn btn-sm btn-light btn-block"
							>Создать профиль</router-link
						>
					</div>
					<div class="mb-3">
						<div v-if="message" class="alert alert-danger" role="alert">{{ message }}</div>
					</div>
				</form>
			</ValidationObserver>
		</div>
	</div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import User from "../../models/user";

export default {
	name: "Login",
	metaInfo: {
		title: "Вход",
		meta: [{ name: "description", content: "Страница входа" }],
	},
	components: {
		ValidationProvider,
		ValidationObserver,
	},
	data() {
		return {
			user: new User("", ""),
			loading: false,
			message: "",
		};
	},

	computed: {
		loggedIn() {
			return this.$store.state.auth.status.loggedIn;
		},
	},

	methods: {
		submit() {
			this.loading = true;

			if (this.user.email && this.user.password) {
				this.$store.dispatch("auth/login", this.user).then(
					() => {
						if (this.loggedIn) {
							if (this.$route.params.redirect) {
								this.$router.push(this.$route.params.redirect);
							} else {
								this.$router.push("/profile");
							}
						}
					},
					(error) => {
						this.loading = false;
						this.message = error.response.data.message || error.toString();
					}
				);
			}
		},
	},

	created() {
		if (this.loggedIn) {
			if (this.$route.params.redirect) {
				this.$router.push(this.$route.params.redirect);
			} else {
				this.$router.push("/profile");
			}
		}
	},
};
</script>

<style scoped>
label {
	display: block;
	margin-top: 10px;
}

.card-container.card {
	max-width: 400px !important;
	padding: 40px 40px;
}

.card {
	background-color: #f7f7f7;
	padding: 20px 25px 30px;
	margin: 0 auto 25px;
	margin-top: 50px;
	-moz-border-radius: 2px;
	-webkit-border-radius: 2px;
	border-radius: 2px;
	-moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
	-webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
	box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}

.profile-img-card {
	width: 96px;
	height: 96px;
	margin: 0 auto 10px;
	display: block;
	-moz-border-radius: 50%;
	-webkit-border-radius: 50%;
	border-radius: 50%;
}
</style>
